import React from 'react'

export const DashboardEmpty = () => {
  return (
    <div>DashboardEmpty</div>
  )
}

 